"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames4 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _imageUrlModifier = require("../../utils/imageUrlModifier/imageUrlModifier");
var _config = _interopRequireDefault(require("./config"));
var _DEPRECATED_CarouselModule = _interopRequireDefault(require("./DEPRECATED_Carousel.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "children", "variant", "thumbnails", "largeChevrons", "thumbnailProps", "dotType", "handleImageChange"];
/**
 * @deprecated This component will be removed in version 27 or 28
 */
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var propTypes = {
  /** Contents of the carousel */
  children: _propTypes.default.node.isRequired,
  /** Which pre-configured type of carousel to use ('multi-product' | 'multi-product-peek' | 'image-gallery') */
  variant: _propTypes.default.oneOf(['multi-product', 'multi-product-peek', 'image-gallery']),
  /** Custom classname for the carousel wrapper */
  className: _propTypes.default.string,
  /** Called afterChange */
  handleImageChange: _propTypes.default.func,
  /** Array of image source strings to use as image thumbnails */
  thumbnails: _propTypes.default.arrayOf(_propTypes.default.string),
  /** Default number of slides to show at largest breakpoint */
  slidesToShow: _propTypes.default.number,
  /** Default number of slides to page past at largest breakpoint */
  slidesToScroll: _propTypes.default.number,
  /** Enable wraparound scrolling */
  infinite: _propTypes.default.bool,
  /** Display pagination indicators beneath carousel */
  dots: _propTypes.default.bool,
  /** Dots or Dashes, changes the appearence of the dots */
  dotType: _propTypes.default.oneOf(['dots', 'dashes']),
  /** Use large rounded chevrons type */
  largeChevrons: _propTypes.default.bool,
  /** Custom class to apply to carousel pagination */
  dotsClass: _propTypes.default.string,
  /** Constructor to specify custom pagination buttons */
  customPaging: _propTypes.default.func,
  /** Array of rules for changing config options at different breakpoints */
  responsive: _propTypes.default.arrayOf(_propTypes.default.shape({
    breakpoint: _propTypes.default.number,
    // https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/issues/224

    settings: _propTypes.default.object
  }))
};
function moveThumbnails(index, elRef) {
  if (!elRef.current) {
    return;
  }
  var carousel = elRef.current.innerSlider.list.offsetParent;
  var thumbnails = carousel === null || carousel === void 0 ? void 0 : carousel.querySelector('ul');
  if (thumbnails) {
    var thumbnail = thumbnails.children[index];
    var thumbnailWidth = thumbnail.offsetWidth;
    var thumbnailOffset = thumbnail.offsetLeft;
    var thumbnailsWidth = thumbnails.offsetWidth;
    thumbnails.scrollLeft = thumbnailOffset + thumbnailWidth / 2 - thumbnailsWidth / 2;
  }
}
var DEPRECATED_Carousel = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, sliderRef) {
  var className = _ref.className,
    children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'multi-product' : _ref$variant,
    _ref$thumbnails = _ref.thumbnails,
    thumbnails = _ref$thumbnails === void 0 ? [] : _ref$thumbnails,
    largeChevrons = _ref.largeChevrons,
    thumbnailProps = _ref.thumbnailProps,
    _ref$dotType = _ref.dotType,
    dotType = _ref$dotType === void 0 ? 'dashes' : _ref$dotType,
    _ref$handleImageChang = _ref.handleImageChange,
    handleImageChange = _ref$handleImageChang === void 0 ? function () {} : _ref$handleImageChang,
    overrides = _objectWithoutProperties(_ref, _excluded);
  var hasThumbnails = thumbnails && thumbnails.length;
  var customPaging = function customPaging(index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      "aria-label": "Go to slide ".concat(index + 1),
      className: (0, _classnames4.default)(_defineProperty(_defineProperty(_defineProperty({}, _DEPRECATED_CarouselModule.default['c-carousel__pagination-image'], hasThumbnails), _DEPRECATED_CarouselModule.default['c-carousel__pagination-button'], !hasThumbnails && dotType === 'dashes'), _DEPRECATED_CarouselModule.default['c-carousel__pagination-button-dots'], !hasThumbnails && dotType === 'dots')),
      children: thumbnails && thumbnails.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread({
        alt: "",
        src: (0, _imageUrlModifier.formatAmplienceImageURL)(thumbnails[index])
      }, thumbnailProps))
    });
  };
  var appendDots = function appendDots(dots) {
    var activeIndex = dots.findIndex(function (dot) {
      return dot.props.className === 'slick-active';
    });
    if (dotType === 'dashes') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        children: dots.map(function (dot) {
          return /*#__PURE__*/(0, _react.cloneElement)(dot);
        })
      });
    }
    var ulStyles;
    if (dots.length > 3) {
      ulStyles = {
        // This transform is working out how far in pixels to translate the dots to the left
        style: {
          transform: "translateX(".concat(-16 * Math.min(Math.max(0, activeIndex - 1), dots.length - 3), "px)")
        }
      };
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", _objectSpread(_objectSpread({
        className: _DEPRECATED_CarouselModule.default['c-carousel__dots-list']
      }, ulStyles), {}, {
        children: dots.map(function (dot, i) {
          if (activeIndex - 1 === i) {
            return /*#__PURE__*/(0, _react.cloneElement)(dot, {
              className: _DEPRECATED_CarouselModule.default['c-carousel__before-active']
            });
          }
          if (activeIndex === i) {
            return /*#__PURE__*/(0, _react.cloneElement)(dot, {
              className: _DEPRECATED_CarouselModule.default['c-carousel__active-dot']
            });
          }
          return dot;
        })
      }))
    });
  };
  var config = Object.assign({}, _config.default.global || {}, {
    customPaging: customPaging,
    appendDots: appendDots
  }, _config.default[variant] || {}, overrides);

  // https://github.com/akiran/react-slick/issues/1298
  var _ref2 = config || {},
    onSwipe = _ref2.onSwipe,
    beforeChange = _ref2.beforeChange;
  var ref = sliderRef || /*#__PURE__*/(0, _react.createRef)();
  config.onSwipe = function () {
    if (ref.current) {
      ref.current.innerSlider.clickable = true;
    }
    // Still trigger any configured onSwipe as well
    if (onSwipe) {
      onSwipe();
    }
  };
  if (dotType === 'dots') {
    config.dotsClass = (0, _classnames4.default)(_DEPRECATED_CarouselModule.default['c-carousel__pagination--dots'], _defineProperty({}, _DEPRECATED_CarouselModule.default['c-carousel__more-than-three'], _react.Children.count(children) > 3));
  }
  if (variant === 'image-gallery' && thumbnails.length) {
    config.dotsClass += " ".concat(_DEPRECATED_CarouselModule.default['c-carousel__pagination--thumbs']);
    config.beforeChange = function (oldIndex, newIndex) {
      moveThumbnails(newIndex, ref);
      // Still trigger any configured beforeChange as well
      if (beforeChange) {
        beforeChange(oldIndex, newIndex);
      }
    };
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSlick.default, _objectSpread(_objectSpread({
    ref: ref,
    className: (0, _classnames4.default)(className, _DEPRECATED_CarouselModule.default['c-carousel'], _defineProperty(_defineProperty({}, _DEPRECATED_CarouselModule.default['c-carousel--with-peek'], variant === 'multi-product-peek'), _DEPRECATED_CarouselModule.default['c-carousel--with-large-chevrons'], largeChevrons === true))
  }, config), {}, {
    "data-jlds": true,
    handleImageChange: handleImageChange,
    children: _react.default.Children.map(children, function (child, index) {
      return /*#__PURE__*/(0, _react.cloneElement)(child, {
        'data-jlds': "true",
        'data-testid': "carousel-item-".concat(index)
      });
    })
  }));
});
DEPRECATED_Carousel.displayName = 'DEPRECATED_Carousel';
DEPRECATED_Carousel.propTypes = propTypes;
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(DEPRECATED_Carousel);